import { render, staticRenderFns } from "./MallHotel.vue?vue&type=template&id=1aa3fd66&scoped=true&"
import script from "./MallHotel.vue?vue&type=script&lang=js&"
export * from "./MallHotel.vue?vue&type=script&lang=js&"
import style0 from "./MallHotel.vue?vue&type=style&index=0&id=1aa3fd66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa3fd66",
  null
  
)

export default component.exports